import React from 'react'
import { ContainerBall, TextBall } from './styles'

export const Ball = ({ text }) => {
  return <ContainerBall>{text && <TextBall>{text}</TextBall>}</ContainerBall>
}
